import "mutationobserver-shim";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/scss/global.scss";
import "@/assets/index.css";
import "vuetify/styles";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { createVuetify } from "vuetify";
import * as Sentry from "@sentry/vue";

const vuetify = createVuetify({
  components: {
    ...components,
  },
  directives,
  defaults: {
    VDataTable: {
      fixedHeader: true,
      noDataText: "Resultados não encontrados",
    },
  },
});

const app = createApp(App).use(vuetify).use(router);

Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DNS,
  integrations: [Sentry.browserTracingIntegration({ router })],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

app.mount("#app");
